import * as React from "react";
import type { SVGProps } from "react";
const SvgLightbulb = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path fill="#D3ECF8" d="M39.038 61.956h-14.03v-6.908h14.03v6.908Z" />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M34.09 18.678c4.427.548 8.257 2.835 10.31 5.29 3.23 3.86 3.873 8.084 3.387 11.701-.479 3.563-2.054 6.571-3.358 8.157-1.729 2.519-2.794 5.72-3.414 8.879a40.956 40.956 0 0 0-.737 8.394c.025 1.215-.938 2.278-2.204 2.278h-11.77c-1.237 0-2.193-1.023-2.189-2.22.035-8.869-2.755-14.689-4.11-16.454l-.008-.01-.008-.011c-6.235-8.66-3.606-16.99.084-20.763m14.018-5.24c-4.472-.554-9.552.669-14.017 5.24Zm-.215 1.736c-3.958-.49-8.486.566-12.55 4.727-3.134 3.203-5.621 10.585.076 18.507 1.628 2.13 4.499 8.338 4.463 17.515a.452.452 0 0 0 .439.463h11.77c.236 0 .46-.207.455-.493-.046-2.273.121-5.46.769-8.766.646-3.297 1.782-6.77 3.711-9.567l.022-.032.025-.03c1.107-1.333 2.56-4.052 2.996-7.302.433-3.22-.133-6.925-2.994-10.345l.567-.474-.567.474c-1.758-2.103-5.18-4.181-9.182-4.677Z"
      clipRule="evenodd"
    />
    <path fill="#D3ECF8" d="M39.038 58.994h-14.03v-3.946h14.03v3.946Z" />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M24.133 54.173h15.78v5.696h-15.78v-5.696Zm1.75 1.75v2.196h12.28v-2.196h-12.28ZM57.932 53.612a.875.875 0 0 1-1.228.156l-8.243-6.39a.875.875 0 0 1 1.072-1.383l8.243 6.39a.875.875 0 0 1 .156 1.227ZM6.9 53.612a.875.875 0 0 0 1.228.156l8.243-6.39a.875.875 0 0 0-1.072-1.383l-8.243 6.39a.875.875 0 0 0-.156 1.227ZM63.556 26.01a.875.875 0 0 1-.648 1.054l-10.144 2.424a.875.875 0 0 1-.406-1.702l10.144-2.424a.875.875 0 0 1 1.054.648ZM1.276 26.01a.875.875 0 0 0 .648 1.054l10.144 2.424a.875.875 0 0 0 .406-1.702L2.331 25.362a.875.875 0 0 0-1.055.648ZM46.317 3.639a.875.875 0 0 1 .405 1.169l-4.555 9.382a.875.875 0 1 1-1.574-.764l4.555-9.382a.875.875 0 0 1 1.17-.405ZM18.515 3.639a.875.875 0 0 0-.405 1.169l4.555 9.382a.875.875 0 1 0 1.574-.764l-4.555-9.382a.875.875 0 0 0-1.17-.405Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLightbulb;
